'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadr';
var iconName = 'face-zipper';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e3a5';
var svgPathData = ['M80.1 256c0 114.9 93.1 208 208 208 27.6 0 53.9-5.4 77.9-15.1 2.1 2.7 4.3 5.2 6.8 7.7l28.9 28.9c14.8-7.3 28.8-16.1 41.8-26l-36.8-36.8c-12.5-12.5-12.5-32.8 0-45.3l34.7-34.7c12.5-12.5 32.8-12.5 45.3 0l29.6 29.6c7.9-15.5 14.3-31.9 18.9-49l-14.5-14.5c-8.1-8.1-17.5-14.1-27.5-18 1.9-11.3 2.9-22.9 2.9-34.7 0-114.9-93.1-208-208-208s-208 93.1-208 208zm88 64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 32c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-32zm72-112a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm8 112c0-13.3 10.7-24 24-24s24 10.7 24 24l0 32c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-32zm80 0c0-13.3 10.7-24 24-24s24 10.7 24 24l0 32c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-32zm72-112a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z', 'M80.1 256c0-114.9 93.1-208 208-208s208 93.1 208 208c0 11.8-1 23.4-2.9 34.7 10 3.9 19.4 9.9 27.5 18l14.5 14.5c5.8-21.4 8.9-43.9 8.9-67.2 0-141.4-114.6-256-256-256s-256 114.6-256 256 114.6 256 256 256c40.8 0 79.4-9.5 113.6-26.5l-28.9-28.9c-2.4-2.4-4.7-5-6.8-7.7-24.1 9.7-50.4 15.1-77.9 15.1-114.9 0-208-93.1-208-208zm160-48a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-96 56c-13.3 0-24 10.7-24 24l0 32c0 13.3 10.7 24 24 24s24-10.7 24-24l0-32c0-13.3-10.7-24-24-24zm104 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 32c0 13.3 10.7 24 24 24s24-10.7 24-24l0-32zm-184-24c-13.3 0-24 10.7-24 24l0 32c0 13.3 10.7 24 24 24s24-10.7 24-24l0-32c0-13.3-10.7-24-24-24zm344 96l-49.4-49.4c-12.5-12.5-32.8-12.5-45.3 0l-34.7 34.7c-12.5 12.5-12.5 32.8 0 45.3L456.1 472c22.1 22.1 57.9 22.1 80 0s22.1-57.9 0-80zm-56 40a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFaceZipper = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;